<template>
    <div>
        <CicPopup
            id="edit_percentage_split"
            :title="item.profileId ? 'Edit Percentage Split Profile' : 'New Percentage Split Profile'"
            :saveable="editing"
            class="no-padding"
            @blur="$emit('blur')"
            @input="$emit('input')"
        >
            <div class="item-form">
                <ul>
                    <li class="form-label-first">
                        {{ $t('Profile Name') }}
                    </li>
                    <li>
                        <CicTextbox
                            id="profile_name"
                            :enabled="editing"
                            :value="item.name"
                            :maxlength="63"
                            @input="(val) => updateFieldValue('name', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('Description') }}
                    </li>
                    <li>
                        <CicTextbox
                            id="profile_description"
                            :enabled="editing"
                            :value="item.description"
                            :maxlength="255"
                            @input="(val) => updateFieldValue('description', val)"
                        />
                    </li>
                </ul>
            </div>
            <table id="split_routes" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Default') }}</th>
                        <th>{{ $t('Weight (%)') }}</th>
                        <th class="call-cap">{{ $t('Call Cap') }}</th>
                        <th>{{ $t('Split Route') }}</th>
                        <th v-if="editing" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(itemRoute, index) in item.routes">
                        <td>
                            <CicCheckbox
                                :enabled="editing"
                                :value="itemRoute.default"
                                @input="(val) => updateRouteParam(index, 'default', val)"
                            />
                        </td>
                        <td>
                            <CicTextbox
                                :enabled="editing"
                                :value="itemRoute.weight"
                                int-only
                                @input="(val) => updateRouteParam(index, 'weight', val)"
                            />
                        </td>
                        <td class="call-cap">
                            <CicCheckbox
                                :enabled="editing"
                                :value="itemRoute.callCap > 0"
                                @input="(val) => updateRouteParam(index, 'callCap', val ? 1 : -1)"
                            />
                            <CicTextbox
                                v-if="itemRoute.callCap > 0"
                                :enabled="editing"
                                :value="itemRoute.callCap"
                                int-only
                                @input="(val) => updateRouteParam(index, 'callCap', val)"
                            />
                        </td>
                        <td>
                            <RouteLabel :route="itemRoute.route" @click="openRoute(index)" />
                        </td>
                        <td v-if="editing">
                            <IconButton icon="remove-icon" @click="removeRoute(index)" />
                        </td>
                    </tr>
                    <tr v-if="editing">
                        <td colspan="4"></td>
                        <td><IconButton icon="add-icon" @click="openRoute(-1)" /></td>
                    </tr>
                </tbody>
            </table>
        </CicPopup>

        <ServiceSelector
            v-if="route"
            :editing="editing"
            :route="route"
            @change="updateRouteValue"
            @input="updateRoute"
            @blur="handleBlur"
            @remove="removeRoute(routeIndex)"
        />
    </div>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import { getRoute, getUpdatedRoute } from '@/utils/RouteCollectionUtils';
    import ServiceSelector from '../../serviceSelector/ServiceSelector';
    import RouteLabel from '../autoAttendants/RouteLabel';

    export default {
        name: 'EditPercentageSplit',
        components: {
            CicCheckbox,
            CicPopup,
            CicTextbox,
            IconButton,
            RouteLabel,
            ServiceSelector,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'changeList', 'input'],
        data() {
            return {
                editing: false,
                route: null,
                routeIndex: null,
            };
        },
        created() {
            this.editing = !this.item.profileId || this.$store.hasRight('EDIT_PERCENT_SPLIT');
        },
        methods: {
            handleBlur() {
                this.route = null;
                this.routeIndex = null;
            },

            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },

            openRoute(index) {
                if (index >= 0) {
                    this.routeIndex = index;
                    this.route = { ...this.item.routes[index].route };
                } else {
                    this.routeIndex = index;
                    this.route = getRoute(1);
                }
            },

            removeRoute(index) {
                this.route = null;
                this.routeIndex = null;
                if (index >= 0) {
                    const routes = JSON.parse(JSON.stringify(this.item.routes));
                    routes.splice(index, 1);
                    this.updateFieldValue('routes', routes);
                }
            },

            updateRoute() {
                const routes = JSON.parse(JSON.stringify(this.item.routes));
                if (this.routeIndex >= 0) {
                    routes[this.routeIndex].route = this.route;
                } else {
                    const weight = routes.reduce((a, route) => a - route.weight, 100);
                    routes.push({ route: this.route, weight: weight > 0 ? weight : 0, callCap: -1, default: false });
                    this.$nextTick(() => {
                        this.$nextTick(() => {
                            const body = document
                                .getElementById('edit_percentage_split')
                                .getElementsByClassName('cic-popup-body')[0];
                            body.scrollTop = body.scrollHeight;
                        });
                    });
                }

                this.route = null;
                this.routeIndex = null;
                this.updateFieldValue('routes', routes);
            },

            updateRouteParam(index, name, val) {
                const routes = JSON.parse(JSON.stringify(this.item.routes));
                if (name === 'default' && val) {
                    routes.map((x) => (x.default = false));
                }

                routes[index][name] = val;
                this.updateFieldValue('routes', routes);
            },

            updateRouteValue(field, val) {
                this.route = getUpdatedRoute(this.route, field, val);
                if (
                    (this.route.type === 6 && field === 'mappingType') ||
                    ([1, 2].includes(this.route.type) && field === 'mediaListId')
                ) {
                    this.$emit('changeList', val);
                }
            },
        },
    };
</script>
